import { HttpTransportType, HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import { selector } from 'recoil'

import { $apiClient } from '../core'

interface WebsocketTokenResponse {
  success: boolean
}

export const $signalr = selector({
  key: 'SignalR',
  get: async ({ get }) => {
    try {
      const client = get($apiClient)
      await client.read<WebsocketTokenResponse>('IDP/api/TokenConversion/NegotiateWebsocketToken', undefined, true)

      const url = window.__APP_CONFIG__.API + '/genericHub'
      const connection = new HubConnectionBuilder()
        .withUrl(url, {
          withCredentials: true,
          skipNegotiation: true,
          transport: HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect()
        .configureLogging(LogLevel.Error)
        .build()

      await connection.start()
      return connection
    } catch (error) {
      //avoid trowing errors when we can't open the websocket, return a fake object
      console.warn('[SignalR] - error connecting to signalr socket, real time notification will not work.', error)
      return {
        send: (_: string, ...__: any[]): Promise<void> => {
          return Promise.resolve()
        },
        invoke: <T = any>(_: string, ...__: any[]): Promise<T> => {
          return Promise.resolve({} as any)
        },
        on: (_: string, __: (...args: any[]) => any): void => {},
        off: (_: string, __: (...args: any[]) => void): void => {},
        onclose: (_: (error?: Error) => void): void => {},
        onreconnecting: (_: (error?: Error) => void): void => {},
        onreconnected: (_: (connectionId?: string) => void): void => {},
      } as HubConnection
    }
  },
  dangerouslyAllowMutability: true,
})
